import { Navigate } from 'react-router-dom'
import { isFeatureEnabled, type FeatureFlag } from '@/config/featureFlags'

interface FeatureGuardProps {
  feature: FeatureFlag
  children: React.ReactNode
}

/**
 * Guards a route based on feature flags.
 * Redirects to home if feature is disabled.
 */
export function FeatureGuard({ feature, children }: FeatureGuardProps) {
  if (!isFeatureEnabled(feature)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
